// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

import { createElement, Component, PropTypes, Button, Translate, Dialog } from '@plesk/ui-library';

class CloudBackupRestriction extends Component {
    state = {
        visible: true,
    };

    componentWillReceiveProps() {
        this.setState({
            visible: true,
        });
    }

    handleClose = () => {
        this.setState({
            visible: false,
        });
    }

    render() {
        return (
            <Dialog
                isOpen={this.state.visible}
                size="sm"
                banner={`${Jsw.skinUrl}/images/plesk-backup.png`}
                cancelTitle={<Translate content="closeButton" />}
                buttons={
                    this.props.buyUrl ? (
                        <Button
                            intent="primary"
                            icon="shopping-cart"
                            component="a"
                            href={this.props.buyUrl}
                            target={this.props.buyUrlNewWindow ? '_blank' : false}
                            onClose={this.handleClose}
                        >
                            <Translate content="buyButton" />
                        </Button>
                    ) : null
                }
                onClose={this.handleClose}
            >
                <Translate content={this.props.buyUrl ? 'descriptionWithBuy' : 'description'} />
            </Dialog>
        );
    }
}
CloudBackupRestriction.propTypes = {
    buyUrl: PropTypes.string,
    buyUrlNewWindow: PropTypes.bool,
};
CloudBackupRestriction.defaultProps = {
    buyUrl: null,
    buyUrlNewWindow: true,
};

export default CloudBackupRestriction;



// WEBPACK FOOTER //
// ./app/cloud-backup-restriction/CloudBackupRestriction.js